<template>
  <div>
    <el-form
      role="form"
      @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-4">
          <base-input
            label="Select Field">
            <el-select
              v-model="currentFilter"
              selected-filters:-
            >
              <el-option
                label="Customer"
                value="customer"
              />
              <el-option
                label="Vendor"
                value="vendor"
              />
              <el-option
                label="Created At"
                value="createdAt"
              />

              <el-option
                label="Service Request Number"
                value="number"/>
              <el-option
                label="Status"
                value="status"/>
              <el-option
                label="Category"
                value="category"/>
                <el-option
                label="Completed At"
                value="completedAt"
              />
          </el-select></base-input>
        </div>
        <div class="col-md-8">
          <base-input
            v-if="currentFilter === 'status'"
            label="Select Value">
            <el-select v-model="selectedValue">
              <el-option
                v-for="(item, index) in statuses"
                :key="index"
                :value="item.value"
                :label="item.label"/>
            </el-select>
          </base-input>
          <base-input
            v-if="currentFilter === 'category'"
            label="Select Value">
            <el-select v-model="selectedValue">
              <el-option
                v-for="(item, index) in categories"
                :key="index"
                :value="item.value"
                :label="item.label"/>
            </el-select>
          </base-input>
          <base-input
            v-else-if="currentFilter != 'createdAt' && currentFilter != 'status'  && currentFilter != 'completedAt' "
            v-model="selectedValue"
            selected-filters:-
            label="Value"
            placeholder="Type Value"/>

          <base-input
            v-if="currentFilter === 'createdAt' || currentFilter === 'completedAt'"
            label="Select Date Range">
            <el-date-picker
              v-model="selectedValue"
              type="daterange"
              range-separator="-"
              start-placeholder="Start"
              end-placeholder="End"
              value-format="yyyy-MM-dd"
            />
          </base-input>
        </div>
      </div>
      <base-button
        type="primary"
        native-type="submit">Apply</base-button>
    </el-form>
  </div>
</template>

<script>
import {Form, Select, Option, DatePicker} from 'element-ui';
export default {
components: {
   [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [DatePicker.name] : DatePicker
},
data() {
  return {
    currentFilter: null,
    selectedValue: null,
    categories: [
      {
        value: 'Electrician',
        label: 'Electrician'
      },
      {
        value: 'Motor Mechanic',
        label: 'Motor Mechanic'
      },
      {
        value: 'Appliances Repair',
        label: 'Appliances Repair'
      },
      {
        value: 'Helper',
        label: 'Helper'
      },
      {
        value: 'Repair Work',
        label: 'Repair Work'
      },
      {
        value: 'Plumbing',
        label: 'Plumbing'
      },
    ],
    statuses : [
      {
      value : 'pending',
      label : 'Pending'
    },{
      value : 'visited',
      label : 'Visited'
    }, {
      value : 'quotation_pending',
      label : 'Quotation Pending'
    },{
      value : 'quotation_completed',
      label : 'Quotation Completed'
    },{
      value : 'assigned',
      label : 'Assigned'
    },{
      value : 'cancelled',
      label : 'Cancelled'
    },{
      value : 'work_in_progress',
      label : 'Work In Progress'
    },{
      value : 'billing',
      label : 'Billing'
    },{
      value : 'payment_pending',
      label : 'Payment Pending'
    },
    {
      value : 'completed',
      label : 'Completed'
    }]
  }
},
methods:{
  onSubmit() {
    this.$emit('apply',{
      field: this.currentFilter,
      value: this.selectedValue
    });
    this.currentFilter = '';
    this.selectedValue = '';
  }
}
}
</script>

<style>

</style>
